<script>
import axios from 'axios'
export default
{
    name: 'image-uploader',

    props:
    {
        text: String,
        type: String,

        width: {
            type: Number,
            default: 256,
        },

        height: {
            type: Number,
            default: 256,
        },

        quality: {
            type: Number,
            default: 1,
        },
        disableDragAndDrop: Boolean,
        disableDragToMove: Boolean,
        disablePinchToZoom: Boolean,
        disableRotation: Boolean,
        disableScrollToZoom: Boolean
    },

    methods:
    {
        upload()
        {
            this.image.generateBlob(blob =>{
                const formData = new FormData()
                const originalFile = this.image.getChosenFile()
                const fileName = originalFile && originalFile.name ? originalFile.name : 'blob'
                formData.append('file', blob, fileName)
                formData.append('type', this.type)
                const url =  `${process.env.API_SERVER}/attachments/upload-image`
                axios.post(url, formData).then(res => {
                    this.$emit('upload-done', res.data)
                    this.reset()
                })
            }, 'image/jpeg', 0.8)
            this.reset()
        },

        reset()
        {
            this.image.remove()
            this.$emit('clean')
        },

        onFileChoose()
        {
            this.$emit('dirty')
        },
    },

    data()
    {
        return {
            image: {}
        }
    },

}
</script>
<template>
    <div class="image-uploader">
        <croppa
            v-model="image"
            :width="width"
            :height="height"
            :quality="quality"
            canvas-color="#f0f0f0"
            placeholder="Add"
            placeholder-color="#222"
            :zoom-speed="20"
            :show-remove-button="false"
            @file-choose="onFileChoose"
            show-loading
            accept="image/*"
            :disableDragAndDrop="disableDragAndDrop"
            :disableDragToMove="disableDragToMove"
            :disablePinchToZoom="disablePinchToZoom"
            :disableRotation="disableRotation"
            :disableScrollToZoom="disableScrollToZoom"
            />
        <div class="engage-button xs text-blue" v-show="image && image.imageSet" @click.prevent.stop="upload">
            Upload
        </div>

        <div class="engage-button xs" v-show="image && image.imageSet" @click.prevent.stop="image.zoomIn">
            <i class="fal fa-search-plus"></i>
        </div>

        <div class="engage-button xs" v-show="image && image.imageSet" @click.prevent.stop="image.zoomOut">
            <i class="fal fa-search-minus"></i>
        </div>

        <div class="engage-button orange text-white xs" v-show="image && image.imageSet" @click.prevent.stop="reset">
            Delete
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/forms/elements/imageUploader.vue